module.exports = __webpack_public_path__ + "img/_110.34e0c52c.png";